import { events } from '@estee/elc-service-bus';
import { Event } from '~entities/Event';
import { EventRepository } from '~repositories/EventRepository';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';

export class AppointmentReviewWidgetClickUseCase {
    private serviceName: string;
    private eventRepository: EventRepository;

    constructor(serviceName: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.serviceName = serviceName;
    }

    public async execute() {
        const appointmentReviewWidgetClickPayload = {
            event_name: 'OAB reviews',
            event_category: 'oab reviews',
            event_action: 'review widget click',
            event_label: this.serviceName
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.APPOINTMENT_REVIEW_WIDGET_CLICK,
            type: 'link',
            payload: appointmentReviewWidgetClickPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    }
}
